"use client";

import { useEffect, useRef, useState } from "react";

interface LazyLoadBoundaryProps {
  children: React.ReactNode;
  className?: string;
  threshold?: number;
  rootMargin?: string;
}

export default function LazyLoadBoundary({
  children,
  className = "",
  threshold = 0.1,
  rootMargin = "50px",
}: LazyLoadBoundaryProps) {
  const [isVisible, setIsVisible] = useState(false);
  const boundaryRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Once visible, disconnect the observer
          observer.disconnect();
        }
      },
      {
        threshold,
        rootMargin,
      },
    );

    if (boundaryRef.current) {
      observer.observe(boundaryRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [threshold, rootMargin]);

  return (
    <div ref={boundaryRef} className={className}>
      {isVisible ? (
        children
      ) : (
        <div style={{ height: "100%", minHeight: "200px" }} />
      )}
    </div>
  );
}
